<template>
	<loader v-if="loading" height="80vh" />
	<div v-else class="container ar">
		<breadcrumbs
			class="ar"
			:links="[
				{ name: 'الرئيسية', link: '/' },
				{ name: 'السلاسل', link: { name: 'all-series' } },
				{ name: serie.name, link: {}, active: true },
			]"
		></breadcrumbs>
		<div class="title">
			<img :src="serie.image" alt />
			{{ serie.name }}
		</div>
		<div class="issn">{{ serie.issn }}</div>
		<div class="sub-title">الاعداد</div>

		<!-- valumes and Dates -->
		<div v-for="item in valumesWithDates" :key="item.date" class="main">
			<div class="main-date">{{ item.date }}</div>
			<div v-for="valume in sortVolume(item.valumes)" :key="valume.id">
				<router-link
					:to="{
						name: 'all-articles',
						params: {
							id: valume.id,
							name: valume.name.replaceSpace(),
							serieId: serieId,
							serieName: serie.name.replaceSpace(),
						},
					}"
					class="d-inline-block"
				>
					{{ valume.name }}
				</router-link>
			</div>
		</div>
		<div class="text-center fs-4 mb-5" v-if="valumesWithDates.length === 0">
			لا يوجد أعداد
		</div>
	</div>
</template>

<script>
import Breadcrumbs from "@/components/Breadcrumbs";
import Loader from "@/components/Loader";
import { moment } from "@/helpers";
export default {
	props: ["serieId"],

	components: {
		Breadcrumbs,
		Loader,
	},

	data() {
		return {
			idToFetch: 0,

			serie: {
				categories: [],
			},

			loading: true,
		};
	},

	methods: {
		moment,
		sortVolume(arr) {
			return arr.sort((a, b) => {
				const A = Number(a.name.split(" ")[1]);
				const B = Number(b.name.split(" ")[1]);
				if (A > B) return 1;
				if (A < B) return -1;
				return 0;
			});
		},
		fetch() {
			this.loading = true;

			this.$store
				.dispatch("series/fetchById", { id: this.idToFetch })
				.then((data) => {
					this.serie = data;
				})
				.then(() => {
					this.loading = false;
				})
				.finally(() => {
					const element = document.querySelectorAll(".main > div");

					const list = new IntersectionObserver((entries) => {
						entries.forEach((entry) => {
							var i = 0;
							if (entry.isIntersecting) {
								(function loop() {
									setTimeout(() => {
										element[i].classList.add("show");
										i++;
										if (i < element.length) loop();
									}, 80);
								})();
							}
						});
					});

					list.observe(document.querySelector(".main"));
				});
		},
	},

	computed: {
		valumesWithDates() {
			var dates = [];
			var data = [];
			this.serie.Volumes.forEach((category) => {
				var categoryDate = category.Date;
				if (dates.find((date) => date === categoryDate)) {
					data.find((c) => c.date === categoryDate).valumes.push(category);
				} else {
					dates.push(categoryDate);
					data.push({ date: categoryDate, valumes: [category] });
				}
			});
			data.sort((a, b) => b.date - a.date);
			return data;
		},
	},
	watch: {
		"$route.params"() {
			this.idToFetch = this.$route.params.id;
			this.fetch();
		},
	},
	mounted() {
		this.idToFetch = this.serieId;
		this.fetch();
	},
};
</script>

<style scoped>
.container {
	margin-top: 50px;
}
.container > * {
	margin: 0 50px;
}
.title {
	text-align: center;
	font-size: 32px;
	font-family: changeBold;
	color: var(--green-color);
	padding: 10px 0 30px;
	border-bottom: 2px solid var(--borders-color);
}
.title > * {
	padding: 10px;
}
.title img {
	height: 60px;
}
.title p {
	max-width: 80%;
	font-family: changeMedium;
	margin: auto;
	font-size: 16px;
}
.issn {
	text-align: left;
	margin-top: -1.8rem !important;
}
.issn::before {
	content: "ISSN: ";
}
.main {
	padding: 0 0 50px;
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	row-gap: 20px;
	column-gap: 10%;
}
.main > div {
	font-size: 20px;
	transform: translateX(30px);
	visibility: hidden;
	transition: 1000ms;
}
/* .main > div.main-date {
  transition: 500ms;
} */
.main > div.show {
	transform: translateX(0);
	visibility: visible;
}
.sub-title {
	text-align: center;
	font-size: 28px;
	font-family: changeBold;
	color: var(--green-color);
	padding: 30px 0 20px;
}
.main-date {
	grid-column-start: 1;
	grid-column-end: 5;
	font-family: changeBold;
	font-weight: 900;
	font-size: 24px !important;
	padding: 20px 0 0;
}
@media only screen and (max-width: 992px) {
	.container > * {
		margin: 0 10px;
	}
	.main {
		grid-template-columns: repeat(3, 1fr);
	}
	.main-date {
		grid-column-end: 4;
	}
}
@media only screen and (max-width: 768px) {
	.title p {
		max-width: none;
	}
	.main {
		grid-template-columns: 1fr 1fr;
		column-gap: 10px;
		row-gap: 10px;
	}
	.main > div {
		font-size: 16px;
		width: max-content;
	}
	.main-date {
		grid-column-end: 3;
	}
}
@media only screen and (max-width: 575px) {
	.main {
		grid-template-columns: 1fr;
	}
	.main-date {
		grid-column-end: 1;
	}
	.title {
		display: flex;
		flex-direction: column;
		align-items: center;
		font-size: 28px;
	}
	.title img {
		width: 80px;
		height: auto;
	}
	.title p {
		font-size: 14px;
	}
}
</style>
